<template>
  <div class="common-form-inline page-main no-shadow">
    <a-form-model
      ref="ruleForm"
      :rules="rules"
      :model="pageData"
      :label-col="{ span: 10 }"
      :wrapper-col="{ span: 7 }"
    >
      <a-form-model-item label="企业名称" prop="cstNm">
        <a-input v-model="pageData.cstNm" disabled />
      </a-form-model-item>

      <a-form-model-item label="社会信用代码" prop="orgCode">
        <a-input v-model="pageData.orgCode" disabled />
      </a-form-model-item>

      <a-form-model-item label="收款账户" prop="accountNo">
        <a-select v-model="pageData.accountNo">
          <a-select-option
            :value="option.accNo"
            v-for="option in tableData"
            :key="option.id"
            >{{ option.accNo }}</a-select-option
          >
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="账户户名" prop="accountName">
        <a-input v-model="accountName" disabled />
      </a-form-model-item>

      <a-form-model-item label="开户银行" prop="accountBank">
        <a-input v-model="accountBank" disabled />
      </a-form-model-item>

      <a-form-model-item label="大额行号" prop="largeBankNo">
        <a-input v-model="largeBankNo" disabled />
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { bindingAccountList } from "@/api/customer.js";
export default {
  components: {},
  data() {
    return {
      pageData: {
        cstNm: this.$store.getters["home/getUserObj"].cstNm,
        orgCode: this.$store.getters["home/getUserObj"].orgCode,
        accountName:undefined,
        accountNo: undefined,
        accountBank: undefined,
        largeBankNo: undefined
      },
      tableData: [],
      rules: {
        cstNm: [
          {
            required: true,
            message: "企业名称不能为空",
            trigger: "blur",
            whitespace: true
          }
        ],
        orgCode: [
          {
            required: true,
            message: "社会信用代码不能为空",
            trigger: "blur",
            whitespace: true
          }
        ],
        accountName:[
          {
            required: true,
            message: "收款账户名称不能为空",
            trigger: "change",
            whitespace: true
          }
        ],
        accountNo: [
          {
            required: true,
            message: "收款账户不能为空",
            trigger: "change",
            whitespace: true
          }
        ],
        accountBank: [
          {
            required: true,
            message: "开户银行不能为空",
            trigger: "change",
            whitespace: true
          }
        ],
        largeBankNo: [
          {
            required: true,
            message: "大额行号不能为空",
            trigger: "change",
            whitespace: true
          }
        ]
      }
    };
  },
  computed: {
    accountName() {
      let item = this.tableData.find(i => i.accNo == this.pageData.accountNo) || {};
      this.pageData.accountName = item.cstNm;
      return item.cstNm;
    },
    accountBank() {
      let item = this.tableData.find(i => i.accNo == this.pageData.accountNo) || {};
      this.pageData.accountBank = item.accBlngBnk;
      this.pageData.accountId = item.id;
      return item.accBlngBnk;
    },
    largeBankNo() {
      let item = this.tableData.find(i => i.accNo == this.pageData.accountNo) || {};
      this.pageData.largeBankNo = item.largeBankNo;
      return item.largeBankNo;
    }
  },
  methods: {
    getTableData() {
      bindingAccountList({
        checkStCd: "1"
      })
        .then(res => {
          this.loading = false;
          this.tableData = res.data.grid.list || [];
        })
        .catch(err => {
          console.log(err);
        });
    },
    check() {
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            resolve({
              ...this.pageData,

            });
          } else {
            return false;
          }
        });
      });
    }
  },
  created() {
    this.getTableData();
    this.pageData.accountNo = this.$route.query.accountNo || undefined;
  },
  mounted() {},
  watch: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/bank/bank-step-base.vue